/**
 * Product Sticky Bar
 * Mobile sticky add-to-cart bar that appears when main CTA scrolls out of view.
 * Uses IntersectionObserver for performance.
 */

(function() {
  'use strict';

  function initStickyBar() {
    // Only run on mobile
    if (window.innerWidth > 749) return;

    const stickyBar = document.querySelector('.product__sticky-bar');
    const mainAddToCart = document.querySelector('.product__quantity-buy-container');

    if (!stickyBar || !mainAddToCart) return;

    // Create intersection observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Main CTA is visible - hide sticky bar
          stickyBar.classList.remove('product__sticky-bar--visible');
          document.body.classList.remove('sticky-bar-visible');
        } else {
          // Main CTA is out of view - show sticky bar
          stickyBar.classList.add('product__sticky-bar--visible');
          document.body.classList.add('sticky-bar-visible');
        }
      });
    }, {
      threshold: 0,
      rootMargin: '-80px 0px 0px 0px' // Account for sticky header
    });

    observer.observe(mainAddToCart);

    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth > 749) {
          stickyBar.classList.remove('product__sticky-bar--visible');
          document.body.classList.remove('sticky-bar-visible');
        }
      }, 100);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }
})();
